import { render, staticRenderFns } from "../alert/alert.html?vue&type=template&id=1c0893b1&scoped=true&external"
import script from "../alert/alert.js?vue&type=script&lang=js&external"
export * from "../alert/alert.js?vue&type=script&lang=js&external"
import style0 from "../alert/alert.css?vue&type=style&index=0&id=1c0893b1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0893b1",
  null
  
)

export default component.exports